import React from 'react';
import { Switch, Route } from 'react-router-dom';
import DefineNewAssessorsForms from './View/DefineNewAssessorsForms';
import AssessorsFormsStatus from './View/AssessorsFormsStatus';
import AssessorsFormsStatusPerPage from './View/components/AssessorsFormsStatusPerPage';
import CheckBankAssessorSResponse from './View/CheckBankAssessorSResponse';
import GetReports from './View/GetReports';
import NeedsCheckAssessmentForms from './View/NeedsCheckAssessmentForms';
import NeedsCheckAssessment from './View/NeedsCheckAssessment';
import ApprovedGeneralAssessmentResults from './View/ApprovedGeneralAssessmentResults';
import OngoingGeneralAssessment from './View/OngoingGeneralAssessment';
import ApprovedGeneralAssessment from './View/ApprovedGeneralAssessment';
import OngoingAssessment from './View/OngoingAssessment';
import NeedsCorrectionAssessment from './View/NeedsCorrectionAssessment';
import ApprovedAssessment from './View/ApprovedAssessment';
import NotFoundComponent from './View/NotFoundComponent';
import SubmittedAssessorsPage from './View/components/SubmittedAssessorsPage';
import ResponseForm from './View/components/ResponseForm';
import checkBankResponse from './View/components/CheckBankResponse';
import GetAssessmentReport from "./View/components/GetAssessmentReport";
function
PrivateRout() {
  return (
    <Switch>
      {/* risk_management_assessor_sideBarItems */}
      <Route restricted={false} path="/checkBankResponse/:id" component={checkBankResponse} />
      <Route restricted={false} path="/created/:id" component={AssessorsFormsStatusPerPage} />
      <Route restricted={false} path="/DefineNewAssessorsForms" component={DefineNewAssessorsForms} />
      <Route restricted={false} path="/CheckBankAssessorSResponse" component={CheckBankAssessorSResponse} />
      <Route restricted={false} path="/GetReports" component={GetReports} />
      <Route restricted={false} path="/getReport/:id" component={GetAssessmentReport} />
      {/*  committee_sideBarItems*/}
      <Route restricted={false} path="/checkAllResponse/:id" component={checkBankResponse} />
      <Route restricted={false} path="/submitted/:id" component={SubmittedAssessorsPage} />
      <Route restricted={false} path="/NeedsCheckAssessmentForms" component={NeedsCheckAssessmentForms} />
      <Route restricted={false} path="/NeedsCheckAssessment" component={NeedsCheckAssessment} />
      <Route
restricted={false}         path="/approvedGeneralAssessmentResults"
        component={ApprovedGeneralAssessmentResults}
      />
      {/* general_assessor_sideBarItems */}
      <Route restricted={false} path="/getGeneralResponse/:id" component={ResponseForm} />
      <Route restricted={false} path="/OngoingGeneralAssessment" component={OngoingGeneralAssessment} />
      <Route restricted={false} path="/approvedGeneralAssessment" component={ApprovedGeneralAssessment} />
      {/* bank_sideBarItems */}
      <Route restricted={false} path="/getResponse/:id" component={ResponseForm} />
      <Route restricted={false} path="/OngoingAssessment" component={OngoingAssessment} />
      <Route restricted={false} path="/NeedsCorrectionAssessment" component={NeedsCorrectionAssessment} />
      <Route restricted={false} path="/approvedAssessment" component={ApprovedAssessment} />
      <Route restricted={false} path="/NotFoundComponent" component={NotFoundComponent} />
      <Route restricted={false} path="/AssessorsFormsStatus" component={AssessorsFormsStatus} />
    </Switch>
  );
}

export default PrivateRout;
